import React from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components/macro';
import Description from 'components/Description/Description';

import hostAvailablePropertyApproved from '../../images/Host_Available_Property_Approved.png';
import hostAvailablePropertyBanned from '../../images/Host_Available_Property_Banned.png';
import hostAvailablePropertyUnregulated from '../../images/Host_Available_Property_Unregulated.png';
import noHostPropertyApproved from '../../images/No_Host_Property_Approved.png';
import noHostPropertyBanned from '../../images/No_Host_Property_Banned.png';
import noHostPropertyUnregulated from '../../images/No_Host_Property_Unregulated.png';

const LegendContainer = styled.div`
box-sizing: border-box;
border: 1px solid ${props => props.theme.color.lightGrey};
padding: 15px;
border-radius: 4px;
`
const LegendDescription = styled(Description)`
  margin-bottom: 0px;
`

const Icon = ({ alt, src }) => <img alt={alt} src={src} width={35} />;

const Legend = () => {
  return (
    <LegendContainer>
      <Row>
        <Col span={24} lg={12}>
          <LegendDescription size="regular">Host Available</LegendDescription>
          <LegendDescription size="small" color="lightGrey">
            <Icon alt="Host Available, Property Approved" src={hostAvailablePropertyApproved} /> Property Approved
          </LegendDescription>
          <LegendDescription size="small" color="lightGrey">
            <Icon alt="Host Available, Property Banned" src={hostAvailablePropertyBanned} /> Property Banned
          </LegendDescription>
          <LegendDescription size="small" color="lightGrey">
            <Icon alt="Host Available, Property Unregulated" src={hostAvailablePropertyUnregulated} /> Property Unregulated
          </LegendDescription>
        </Col>
        <Col span={24} lg={12}>
          <LegendDescription size="regular">No Host</LegendDescription>
          <LegendDescription size="small" color="lightGrey">
            <Icon alt="No Host, Property Approved" src={noHostPropertyApproved} /> Property Approved
          </LegendDescription>
          <LegendDescription size="small" color="lightGrey">
            <Icon alt="No Host, Property Banned" src={noHostPropertyBanned} /> Property Banned
          </LegendDescription>
          <LegendDescription size="small" color="lightGrey">
            <Icon alt="No Host, Property Unregulated" src={noHostPropertyUnregulated} /> Property Unregulated
          </LegendDescription>
        </Col>
      </Row>
    </LegendContainer>
  );
};

export default Legend;
